<template>
  <v-row>
    <v-col md="2">
      <Select
        label="Состояние"
        :items="notificationTypes"
        v-model="filter.type"
        @change="filterNotifications"
        blank
      />
    </v-col>
    <v-col md="12">
      <v-card class="notifiContainer">
        <v-card-text>
          <v-row>
            <v-col md="5" class="notifiContainer__leftSide">
              <v-tabs
                v-model="currentItem"
                grow
                hide-slider
              >
                <v-tab
                  v-for="(item,idx) in notificationConstants"
                  :key="item.id"
                  :href="'#tab-' + idx"
                  @click="changeNotificationKind(item.id)"
                >
                  <span class="label">{{ item.name }}</span>
                </v-tab>
              </v-tabs>
              <ScrollableContainer 
                @scrollOnBottom="handlerScrollBottom"
              >
                <template v-slot:body>
                  <v-list v-if="notifies.length" class="notifiContainer__list" :style="{ maxHeight: MAX_HEIGHT + 'px', overflow: 'auto' }">
                    <v-list-item-group v-model="selectedNotifyIdx">
                      <v-list-item
                        v-for="(item, i) in notifies"
                        :key="i"
                      >
                        <v-list-item-content>
                          <v-list-item-title :class="!item.read_at && 'text-bold'">{{ item.kind.name }}: {{ item.subject || 'Без темы'}}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-row :class="!item.read_at && 'text-bold'">{{item.date}}</v-row>
                          <v-row :class="!item.read_at && 'text-bold'">{{item.time}}</v-row>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                  <div v-else class="header text-center"><span class="label">Уведомлений нет</span></div>
                </template>
              </ScrollableContainer>
            </v-col>
            <v-col md="7" class="notifiContainer__rightSide">
              <div class="header"><span class="label">Текст сообщения</span></div>
              <div class="message-body">{{ selectedNotifyIdx != null ? notifies[selectedNotifyIdx].message : '' }}</div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- <v-btn @click="''"><i class="material-icons">print</i>Печать уведомлений</v-btn> -->
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { FORMAT, BASE } from '@/config'
import { ScrollableContainer, Select } from '@/components/common'
import { GET_CHILD_NOTIFICATIONS, READ_CHILD_NOTIFICATION } from '@/requests/parent'

const ALL_TAB_ID = 'ALL'

export default {
  name: 'NotificationsView',
  components: {
    ScrollableContainer,
    Select
  },
  data() {
    return {
      notificationTypes: [
        { text: 'Прочитанные', value: true },
        { text: 'Непрочитанные', value: false },
      ],
      tab: null,
      tabs: [],
      currentItem: 'tab-0',
      selectedNotifyIdx: null,
      notifies: [],
      limit: BASE.LIMIT,
      lastId: null,
      endOfData: false,
      MAX_HEIGHT: 600,
      filter: {
        type: null,
        kind: null
      }
    }
  },
  computed: {
  ...mapState({
      childId: state => state.child.childId,
      notificationConstants: state => [
        {id: ALL_TAB_ID, name: 'Все'},
        ...state.common.constants.notification_kinds
      ]
    })
  },
  watch: {
    selectedNotifyIdx: function (itemIndex) {
      this.currentNotification = this.notifies[itemIndex]
      if (this.currentNotification && !this.currentNotification.read_at) {
        this.readNotification(this.currentNotification.id)
      }
    }
  },
  mounted() {
    this.loadNotifications()
  },
  methods: {
    changeNotificationKind(kind) {
      this.filter.kind = kind
      this.filterNotifications()
    },
    filterNotifications() {
      this.notifies = []
      this.lastId = null
      this.selectedNotifyIdx = null
      this.loadNotifications()
    },
    handlerScrollBottom() {
      if (!this.endOfData) {
        this.loadNotifications()
      }
    },
    async loadNotifications(params = {}) {
      try {
        const { data } = await GET_CHILD_NOTIFICATIONS(this.childId, {
          last_id: this.lastId,
          limit: this.limit,
          kind: this.filter.kind !== ALL_TAB_ID ? this.filter.kind : null,
          is_readed: this.filter.type,
          ...params
        })
        
        if (data.length) {
          this.lastId = data[data.length - 1].id
          this.notifies = [...this.notifies, ...data.map(n => ({
            ...n,
            date: moment(n.created_at).format(FORMAT.date),
            time: moment(n.created_at).format(FORMAT.shortTime),
            kind: this.notificationConstants.find(nc => nc.id === n.kind)
          }))]

          if (data.length < this.limit) this.endOfData = true
        } else {
          this.endOfData = true
        }
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось получить уведомления'
        })
      }
    },
    async readNotification(id) {
      try {
        const { data } = await READ_CHILD_NOTIFICATION(id, this.childId)
        const notification = this.notifies.find(item => item.id === id)
        notification.read_at = data.read_at
      } catch (error) {
        this.$notify({
          type: 'error',
          text: 'Ошибка обновления уведомления.'
        })
      }
    }
  }
}
</script>
